module.exports = __webpack_public_path__ + "assets/a1f1cbba4c821c3d99b9dc4d9dc50398.png";